var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPowerOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.438,
    height: 15.687,
    viewBox: "0 0 15.438 15.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-power-off",
    "data-name": "Icon awesome-power-off",
    d: "M12.763,1.684a7.718,7.718,0,1,1-8.97,0,.749.749,0,0,1,1.089.24l.492.875a.747.747,0,0,1-.205.965,5.228,5.228,0,1,0,6.222,0,.743.743,0,0,1-.2-.962l.492-.875a.746.746,0,0,1,1.083-.243ZM9.526,8.217V.747A.745.745,0,0,0,8.779,0h-1a.745.745,0,0,0-.747.747v7.47a.745.745,0,0,0,.747.747h1A.745.745,0,0,0,9.526,8.217Z",
    transform: "translate(-0.563)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPowerOff);
export default __webpack_public_path__ + "static/media/icon-power-off.423125705f3b8c547c544fd25c0a6e1f.svg";
export { ForwardRef as ReactComponent };